<template>
    <div class="add-content">

        <ion-item v-if="contentTags.length !== 0">
            <ion-label position="stacked">Ausgewählte Tags</ion-label>
            <div class="selected-tag__container">
                <div v-for="contentTag in contentTags" :key="contentTag.id" class="selected-tag__item">
                    {{ contentTag.title }}
                </div>
            </div>
        </ion-item>

        <form @submit="onSubmit" enctype="multipart/form-data" action="content">
            <ion-item>
                <ion-label position="stacked">Titel <ion-text color="danger">*</ion-text></ion-label>
                <ion-input required :value="title" @ionInput="title = $event.target.value"></ion-input>
            </ion-item>

            <ckeditor :editor="editor" v-model="editorData"  v-if="type != 1" :config="editorConfig" class="form-control"></ckeditor>
            <textarea  v-model="editorData"  v-if="type == 1" class="form-control"></textarea>

            <textarea  v-model="additionalData" class="form-control"  v-if="type == 999"></textarea>

            <ion-item v-if="type == 1">
                <ion-label>Sprache</ion-label>
                <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="codeType" @ionChange="codeType = $event.target.value">
                    <ion-select-option v-for="codeType in codeTypes" :key="codeType" v-bind:value="codeType">{{ codeType }}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item>
                <ion-label>Typ</ion-label>
                <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="type" @ionChange="type = $event.target.value">
                    <ion-select-option v-for="contentType in this.allContentTypes" :key="contentType.id" v-bind:value="contentType.id">{{ contentType.title }}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item>
                <ion-label>Bild1</ion-label>
                <div id="viewimage1"></div>
                <input type="file" id="image1"/>
                <input type="checkbox" id="image1delete"/>
                <ion-icon name="trash" title="Löschen"/>
            </ion-item>

            <ion-item>
                <ion-label>Bild2</ion-label>
                <div id="viewimage2"></div>
                <input type="file" id="image2"/>
                <input type="checkbox" id="image2delete"/>
                <ion-icon name="trash" title="Löschen"/>
            </ion-item>

            <ion-item>
                <ion-label>Bild3</ion-label>
                <div id="viewimage3"></div>
                <input type="file" id="image3"/>
                <input type="checkbox" id="image3delete"/>
                <ion-icon name="trash" title="Löschen"/>
            </ion-item>

            <ion-item>
                <ion-label>Bild4</ion-label>
                <div id="viewimage4"></div>
                <input type="file" id="image4"/>
                <input type="checkbox" id="image4delete"/>
                <ion-icon name="trash" title="Löschen"/>
            </ion-item>

            <ion-item>
                <ion-label>Bild5</ion-label>
                <div id="viewimage5"></div>
                <input type="file" id="image5"/>
                <input type="checkbox" id="image5delete"/>
                <ion-icon name="trash" title="Löschen"/>
            </ion-item>

            <a href="/#/" class="link-button">Abbrechen</a>
            <ion-button type="submit">Speichern</ion-button>
        </form>
    </div>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: 'ContentFields',
        props: ['modus', 'id'],
        methods: {
            ...mapActions(["getSelectedTags", "addContent", "updateContent", "getContent", "setSelectedTags"]),
            onSubmit(e){
                e.preventDefault();
                if(this.modus === 'new') {
                    this.addContent(
                        {
                            type: this.type,
                            title: this.title,
                            description: this.editorData,
                            additionalData: this.additionalData,
                            codeType: this.codeType,
                            image1: (e.target.image1delete.checked ? -1  : e.target.image1.files[0]),
                            image2: (e.target.image2delete.checked ? -1  : e.target.image2.files[0]),
                            image3: (e.target.image3delete.checked ? -1  : e.target.image3.files[0]),
                            image4: (e.target.image4delete.checked ? -1  : e.target.image4.files[0]),
                            image5: (e.target.image5delete.checked ? -1  : e.target.image5.files[0]),
                            tags: this.selectedTagsIds
                        }
                        );
                } else {
                    this.updateContent(
                        {
                            id: parseInt(this.id),
                            type: this.type,
                            title: this.title,
                            description: this.editorData,
                            additionalData: this.additionalData,
                            codeType: this.codeType,
                            image1: (e.target.image1delete.checked ? -1  : e.target.image1.files[0]),
                            image2: (e.target.image2delete.checked ? -1  : e.target.image2.files[0]),
                            image3: (e.target.image3delete.checked ? -1  : e.target.image3.files[0]),
                            image4: (e.target.image4delete.checked ? -1  : e.target.image4.files[0]),
                            image5: (e.target.image5delete.checked ? -1  : e.target.image5.files[0]),
                            tags: this.editContent.tags
                        }
                        );
                }
                this.$router.push('/');
            },
        },
        data() {
            return {
                type: 1,
                title: '',
                image1: '',
                description: '',
                codeType: 'javascript',
                contentTags: [],
                editor: ClassicEditor,
                editorData: '',
                editorConfig: {
                    // The configuration of the editor.
                },
                codeTypes: [
                    'bash',
                    'javascript',
                    'markup',
                    'php',
                    'sql',
                    'yaml',
                ]
            };
        },
        computed: {
            ...mapGetters(["selectedTags", "editContent", "allContentTypes", "allTags"]),
            selectedTagsIds() {
                let selectedTagsIds = [];
                this.selectedTags.forEach(function(selectedTag){
                    selectedTagsIds.push(selectedTag.id);
                    if(selectedTag.parent) {
                        selectedTagsIds.push(selectedTag.parent.id);
                    }
                    if(selectedTag.parentParent) {
                        selectedTagsIds.push(selectedTag.parentParent.id);
                    }
                });

                return selectedTagsIds;
            },

        },
        async created() {
            if(this.id) {
                await this.getContent(this.id);
                let selectedTags = [];
                let allTags = this.allTags;
                this.editContent.tags.forEach(function (contentTagId) {
                    allTags.forEach(function(singleTag){
                        if(singleTag.id == contentTagId) {
                            selectedTags.push(singleTag);
                        }
                    })
                });
                let tagsWithParents = selectedTags;
                this.editContent.tags.forEach(function (contentTagId) {
                    selectedTags.forEach(function(selectedTag){
                        selectedTag.childs.forEach(function(childTag) {
                            //console.log(childTag)
                            if (childTag.id == contentTagId) {
                                tagsWithParents.push(childTag);
                            }
                        });
                    });
                });

                this.contentTags = tagsWithParents;
                this.title = this.editContent.title;
                this.type = this.editContent.type;
                this.editorData = this.editContent.description;


                const blobToImage = (blob2, viewId) => {
                    return new Promise(resolve => {
                        let blob = new Blob([blob2.buffer],{type:blob2.type});
                        const url = URL.createObjectURL(blob);
                        let img = new Image();
                        img.onload = () => {
                            //URL.revokeObjectURL(url);
                            resolve(img);
                        };
                        img.src = url;
                        img.width = 100;
                        document.getElementById(viewId).append(img);
                    })
                };

                if(this.editContent.image1) {
                    await blobToImage(this.editContent.image1, 'viewimage1');
                }
                if(this.editContent.image2) {
                    await blobToImage(this.editContent.image2, 'viewimage2');
                }
                if(this.editContent.image3) {
                    await blobToImage(this.editContent.image3, 'viewimage3');
                }
                if(this.editContent.image4) {
                    await blobToImage(this.editContent.image4, 'viewimage4');
                }
                if(this.editContent.image5) {
                    await blobToImage(this.editContent.image5, 'viewimage5');
                }
            }
        }

    }
</script>

<style scoped>
    textarea {
        width: 100%;
        height: 400px;
    }

    ion-input,
    ion-item {
        --background: #3E4143;
        --color: #B6B6B6;
        --icon-color: #B6B6B6;
    }

    .selected-tag__container {
        margin: 20px 0;
    }

    .selected-tag__item {
        background-color: #5690BD;
        color: white;
        border-radius: 12px;
        display: inline-flex;
        padding: 5px 10px;
        margin-right: 7px;
        align-items: center;
    }

    .link-button {
        text-transform: uppercase;
        margin-top: 40px;
        display: inline-block;
    }

    ion-button {
        float: right;
        margin-top: 40px;
    }

</style>